<script setup>
// SiteUp (M10): resposta a status do WhatsApp.
//
// Citação no mesmo formato da superfície de reply do painel (Base.vue):
// fundo tonal, raio 8, padding 10, miniatura quando houver anexo de mídia,
// rótulo "Respondeu ao seu status" e o texto do status. A resposta do
// cliente vem em texto normal. O rótulo técnico "Tipo: image" NÃO aparece.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from 'next/message/bubbles/Base.vue';
import AttachmentChips from 'next/message/chips/AttachmentChips.vue';
import { useMessageContext } from '../provider.js';

const { contentAttributes, attachments } = useMessageContext();
const { t } = useI18n();

const statusReply = computed(() => contentAttributes.value?.statusReply ?? {});
const statusText = computed(() => statusReply.value.statusText || '');
// Sem fallback pro content cru: ele ainda tem "Tipo: image" e sumiria o
// propósito do cartão se o estruturado viesse sem reply_text.
const replyText = computed(() => statusReply.value.replyText || '');

const mediaAttachments = computed(() => {
  const list = attachments?.value || [];
  return list.filter(item => {
    const fileType = item.fileType ?? item.file_type;
    return ['image', 'video', 'audio'].includes(fileType);
  });
});

const thumbAttachment = computed(() => {
  return (
    mediaAttachments.value.find(item => {
      const fileType = item.fileType ?? item.file_type;
      return fileType === 'image' || fileType === 'video';
    }) || null
  );
});

const thumbUrl = computed(() => {
  const att = thumbAttachment.value;
  if (!att) return '';
  return att.thumbUrl || att.thumb_url || att.dataUrl || att.data_url || '';
});

const remainingAttachments = computed(() => {
  const thumb = thumbAttachment.value;
  const list = attachments?.value || [];
  if (!thumb) return list;
  return list.filter(item => item !== thumb && item.id !== thumb.id);
});
</script>

<template>
  <BaseBubble class="px-4 py-3">
    <div class="flex flex-col gap-2">
      <!-- Mesma superfície de quote do Base.vue (opção A). -->
      <div
        data-testid="status-reply-quote"
        class="rounded-lg bg-n-alpha-black1 p-2.5"
      >
        <div class="flex gap-2 items-start">
          <img
            v-if="thumbUrl"
            :src="thumbUrl"
            alt=""
            class="size-10 rounded-lg object-cover shrink-0"
          />
          <div class="min-w-0 flex flex-col gap-0.5">
            <span
              class="flex items-center gap-1.5 text-[11px] font-semibold opacity-80"
            >
              <span
                class="i-ph-arrow-bend-up-left size-3.5 shrink-0"
                aria-hidden="true"
              />
              {{ t('CONVERSATION.STATUS_REPLY.TITLE') }}
            </span>
            <p v-if="statusText" class="text-xs opacity-70 line-clamp-2 m-0">
              {{ statusText }}
            </p>
          </div>
        </div>
      </div>

      <p v-if="replyText" class="text-sm whitespace-pre-wrap break-words m-0">
        {{ replyText }}
      </p>

      <AttachmentChips
        v-if="remainingAttachments.length"
        :attachments="remainingAttachments"
        class="mt-1"
      />
    </div>
  </BaseBubble>
</template>
